import { BaseApiService } from "./base";

export class AdvisorsApiService extends BaseApiService implements AdvisorsApi.Service {
  public search: AdvisorsApi.SearchFn = (params: AdvisorsApi.SearchRequestSchema) =>
    this.axios.get("/api/v4/advisor_search", { params });

  public resendConfirmationEmail: AdvisorsApi.ResendConfirmationFn = (email) =>
    this.axios.post("/advisor_contact_forms/confirmation", { advisor_contact_form: { email: email } });
}
